<template>
  <section class="login-container">
    <div class="mb-2">
      <v-alert v-if="errorMsg" type="error" :value="true">
        {{ errorMsg }}
      </v-alert>
    </div>

    <form @submit="login">
      <v-card id="login-card">
        <v-card-title>
          <h2>{{ $t('Login.login') }}</h2>
        </v-card-title>
        <v-card-text v-if="intro">
          <div v-html="$t(intro)"></div>
        </v-card-text>
        <v-card-text>
          <v-text-field
            v-if="withInstance"
            ref="instance"
            prefix="https://cloud.zeyos.com/"
            v-model="instance"
            :error="hasErrors"
            :label="$t('Login.instance')"
            :placeholder="$t('Login.instance')"
            required
            class="instance-text-field"
          ></v-text-field>
          <v-text-field
            ref="username"
            v-model="username"
            :error="hasErrors"
            :label="$t('Login.username')"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            :error="hasErrors"
            :label="$t('Login.password')"
            @click:append=""
            :type="isPasswordVisible ? 'text': 'password'"
            required
          >
            <template slot="append">
              <span class="visibility-button" @click="isPasswordVisible = !isPasswordVisible">
                <v-icon>{{isPasswordVisible ? 'visibility_off' : 'visibility'}}</v-icon>
              </span>
            </template>
          </v-text-field>
          <v-switch
            :label="$t('Login.staySignedIn')"
            v-model="persist"
          ></v-switch>
        </v-card-text>
        <v-card-text v-if="outro">
          <div v-html="$t(outro)"></div>
        </v-card-text>
        <v-card-actions class="text-md-center">
          <v-btn depressed large color="primary" class="mx-auto" :loading="isLoading" type="submit">
            {{ $t('Login.login') }} <v-icon class="ml-2">send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </section>
</template>

<script>

export default {
  name: 'Login',
  props: {
    intro: String,
    outro: String,
    withInstance: Boolean,
  },
  data() {
    return {
      username: this.$root.loginPrefilled.login || '',
      password: '',
      instance: this.$root.loginPrefilled.instance || '',
      persist: false,
      errorMsg: '',
      isLoading: false,
      isPasswordVisible: false
    };
  },
  computed: {
    visibleIcon() {
      return this.$root.visibleIcon(this.isPinVisible);
    },
    hasErrors() {
      return this.errorMsg !== '';
    }
  },
  mounted() {
    (this.$refs.instance || this.$refs.username).focus();
  },
  methods: {
    login(event) {
      event.preventDefault();
      this.isLoading = true;

      const username = this.username + (this.withInstance ? '@' + this.instance : '');

      this.$http.post(this.$root.route('auth'), {
        username,
        password: this.password
      })
        .then(
          // Success
          response => {
            this.isLoading = false;
            this.$emit('login', response.body.result, this.persist)
          },
          // Failure
          response => {
            this.isLoading = false;
            switch (response.status) {
              case 401:
                this.errorMsg = this.$i18n.t('Login.invalidUserOrPwd');
                break;
              default:
                this.errorMsg = response.body.error;
                // this.errorMsg = this.$i18n.t('Common.errorUploadInvalidResp');
                break;
            }
          }
      );
    }
  }
}
</script>

<style>
  .login-container {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  #login-card {
    max-width: 360px;
    margin: auto;
  }
  .visibility-button {
    cursor: pointer;
    user-select: none;
  }
  .instance-text-field .v-text-field__prefix {
    width: 200px !important;
  }

  .instance-text-field label {
    /*left: 200px !important;*/
  }
</style>
